import { render, staticRenderFns } from "./DriverManage.vue?vue&type=template&id=70c93146&scoped=true&"
import script from "./DriverManage.vue?vue&type=script&lang=js&"
export * from "./DriverManage.vue?vue&type=script&lang=js&"
import style0 from "./DriverManage.vue?vue&type=style&index=0&id=70c93146&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c93146",
  null
  
)

export default component.exports